import React from "react";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Navigate, useNavigate, useOutletContext,Link } from "react-router-dom";
import MembGameSvcItemOdrLstInqApi from "Apis/MembGameSvcItemOdrLstInqApi";
import MembGameSvcItemPrsnLstInqApi from "Apis/MembGameSvcItemPrsnLstInqApi";
import Pagination from "react-js-pagination";
import GameSvcSelectWithDatePicker from "Components/GameSvcSelectWithDatePicker";
import MembGameSvcMnyInqUi from "./MembGameSvcMnyInqUi";
import { getDefaultDateRange, useModalBodyScroll } from "./orderListCommon";



const MembGameSvcGiftOdrLstUi = () => {
    const langData:any = useOutletContext();
    const [pageState, setPageState] = useState(1);
    const [onePageSizeState,setOnePageSizeState] = useState();
    const [totPstdCntState,setTotPstdCntState] = useState(1);
    const [itemPchsOdrLstState,setItemPchsOdrLstState] = useState<any>();
    const [selectedSvcCdState,setselectedSvcCdState] = useState("");
    const [selectedSvcNmState,setselectedSvcNmState] = useState<any>(langData?.MYPAGE_SELT_VAL_ALL_DESC_00 || "전체");
    const [mdalState,setmdalState] = useState(false);
    const [currentStartDate, setCurrentStartDate] = useState("");
    const [currentEndDate, setCurrentEndDate] = useState("");

    useModalBodyScroll(mdalState);

    const navigate = useNavigate();
    
    var popupX = Math.round(window.screenX + (window.outerWidth/2) - (500/2));
    var popupY = Math.round(window.screenY + (window.outerHeight/2) - (765/2));
    const GameMnyPopFunc = (e:any)=>{
        window.open(e,"_blank","width=500,height=765 left="+popupX+"top="+popupY);
    }

    const handlePageChange = (pageState:any) => {
        setPageState(pageState);
        
        // 현재 선택된 날짜 범위 사용
        MembGameSvcItemPrsnLstInqApi(selectedSvcCdState,pageState,currentStartDate,currentEndDate)
        .then((resp)=>{
            setItemPchsOdrLstState(resp.apiBody.itemPchsOdrLst)
            setPageState(resp.apiBody.nowPageNo)
            setOnePageSizeState(resp.apiBody.onePageSize)
            setTotPstdCntState(resp.apiBody.totCnt)
        })
    }; 
    
    const MdalOpenerFunc =(e:string|null) => {
        setmdalState((prev) => !prev);
    }

    // GameSvcSelectWithDatePicker에서 게임 서비스가 변경될 때 호출
    const handleGameServiceChange = (gameSvcCd: string, gameNm: string) => {
        setselectedSvcCdState(gameSvcCd);
        setselectedSvcNmState(gameNm);
        // 날짜는 handleDateChange에서 처리됨
    };

    // GameSvcSelectWithDatePicker에서 날짜가 변경될 때 호출
    const handleDateChange = (startDate: string, endDate: string, gameSvcCd?: string) => {
        // 현재 날짜 범위 저장
        setCurrentStartDate(startDate);
        setCurrentEndDate(endDate);
        
        // 전달받은 gameSvcCd를 우선 사용, 없으면 state 사용
        const currentGameSvcCd = gameSvcCd || selectedSvcCdState;
        
        if (currentGameSvcCd) {
            MembGameSvcItemPrsnLstInqApi(currentGameSvcCd, 1, startDate, endDate)
            .then((resp)=>{
                setItemPchsOdrLstState(resp.apiBody.itemPchsOdrLst);
                setPageState(resp.apiBody.nowPageNo);
                setOnePageSizeState(resp.apiBody.onePageSize);
                setTotPstdCntState(resp.apiBody.totCnt);
            });
        }
    };

    // 초기화 useEffect 추가
    useEffect(()=>{
        setselectedSvcCdState("MGP");
        setselectedSvcNmState(langData?.MYPAGE_SELT_VAL_ALL_DESC_00 || "전체");
        
        const { startDateStr, endDateStr } = getDefaultDateRange();
        setCurrentStartDate(startDateStr);
        setCurrentEndDate(endDateStr);
        
        MembGameSvcItemPrsnLstInqApi("MGP", pageState, startDateStr, endDateStr)
        .then((resp)=>{
            setItemPchsOdrLstState(resp.apiBody.itemPchsOdrLst);
            setPageState(resp.apiBody.nowPageNo);
            setOnePageSizeState(resp.apiBody.onePageSize);
            setTotPstdCntState(resp.apiBody.totCnt);
        });
    },[]);
    
    return(
        <>
        <Helmet>
             <title>{`${process.env.REACT_APP_TITLE_PREFIX} ${langData&&langData.MYPAGE_MENU_MNY_LST_BTN_00}`}</title>
        </Helmet>
        <div className="container1300 BgW pb200">
            <div className="myPageSubTitlWrap">
                <p className="myPageCtxtTitl">{langData&&langData.MYPAGE_MENU_MNY_LST_BTN_00}</p>
            </div>
            <div>
                {/* <div className="myGameSvcMnyWrap">
                    <div className="GameSvcMnyIconWrap">
                        <img src={process.env.PUBLIC_URL + "/images/Mypage/CashIcon.png"} alt="" />
                    </div>
                    <div className="GameSvcMnyTxtWrap">
                        <div className="GameSvcMnyTxtTitl">
                            <h1>{langData&&langData.MYPAGE_MNY_LST_PAGE_TITL_00}</h1>
                            <p>{langData&&langData.MYPAGE_MNY_LST_MAIN_DESC_00}</p>
                        </div>
                    </div>
                </div> */}
                <div className="myGameSvcMnyCtgrMenu">
                    <ul>
                        <li>
                            <Link to="/MyPage/GameSvcMnyDpstLst">
                                <p>{langData&&langData.MYPAGE_MNY_LST_DPST_BTN_01}</p>
                            </Link>
                        </li>
                        <li>
                            <Link to="/MyPage/GameSvcItemOdrLst">
                                <p>{langData&&langData.MYPAGE_MNY_LST_PRCH_BTN_00}</p>
                            </Link>
                        </li>
                        <li className="active">
                            <Link to="/MyPage/GameSvcGiftOdrLst">
                                <p>{langData&&langData.MYPAGE_MNY_LST_GIFT_BTN_00}</p>
                            </Link>
                        </li>
                    </ul>
                </div>
                <div className="myGameSvcMnyCtxtWrap">
                    <div className="myGameSvcMnyTopWrap">
                        <GameSvcSelectWithDatePicker
                            langData={langData}
                            selectedSvcCdState={selectedSvcCdState}
                            selectedSvcNmState={selectedSvcNmState}
                            onGameServiceChange={handleGameServiceChange}
                            onDateChange={handleDateChange}
                            navigate={navigate}
                        />
                        <div className="GameSvcMnyBtnWrap">
                            <button onClick={()=>MdalOpenerFunc(null)}>{langData&&langData.MYPAGE_MAIN_MNY_DPST_BTN_01}</button>
                        </div>
                    </div>
                    <div className="myGameSvcMnydpstOdrLstWrap">
                        <ul className="dpstOdrLstUl">
                            <li className="lstTItlWrap col205">
                                <p className="ctntTitlTxt">{langData&&langData.MYPAGE_MNY_GIFT_CTQR_LBL_00}</p>
                                <p>{langData&&langData.MYPAGE_MNY_GIFT_CTQR_LBL_01}</p>
                                <p>{langData&&langData.MYPAGE_MNY_GIFT_CTQR_LBL_02}</p>
                                <p>{langData&&langData.MYPAGE_MNY_GIFT_CTQR_LBL_03}</p>
                                <p>{langData&&langData.MYPAGE_MNY_GIFT_CTQR_LBL_04}</p>
                            </li>
                            {itemPchsOdrLstState&&itemPchsOdrLstState.length != 0? 
                                <>
                                {itemPchsOdrLstState&&itemPchsOdrLstState.map((key:any, index:number) => (
                                    <li key={index}>
                                        <p className="ctntTitlTxt">{key.gameNm}</p>
                                        <p>{key.target}</p>
                                        <p>{key.prsnMny} {key.gameMnyNm}</p>
                                        <p>{key.odrSttuCd}</p>
                                        <p>{key.prsnDtime}</p>
                                    </li>
                                ))}
                            </>
                            :
                                <li className="noDataLi"><p>{langData&&langData.MYPAGE_MNY_GIFT_NO_DATA_00}</p></li>
                            }
                        </ul>
                        {itemPchsOdrLstState&&itemPchsOdrLstState.length != 0? 
                            <div className="ctntPageWrap">
                                <Pagination
                                    activePage={pageState}
                                    itemsCountPerPage={onePageSizeState}
                                    totalItemsCount={totPstdCntState}
                                    pageRangeDisplayed={5}
                                    firstPageText={""}
                                    linkClassFirst={"pagenationBtn pagenationFirstBtn"}
                                    prevPageText={""}
                                    linkClassPrev={"pagenationBtn pagenationPrevBtn"}
                                    nextPageText={""}
                                    linkClassNext={"pagenationBtn pagenationNextBtn"}
                                    lastPageText={""}
                                    linkClassLast={"pagenationBtn pagenationLastBtn"}
                                    onChange={handlePageChange}
                                />
                            </div>
                        :
                        <></>
                        }
                        
                        
                    </div>
                </div>
            </div>
        </div>
        {mdalState&&(
            <div className="mdalWrap">
                <div className="mdalBg" onClick={()=>MdalOpenerFunc(null)}></div>
                <div className="mdalCtxtWrap contaniner700 mdalCommContainer">
                    <MembGameSvcMnyInqUi></MembGameSvcMnyInqUi>
                    <div className="dpstLstMdalClose">
                        <button  className="mdalCloseBtn"onClick={() => MdalOpenerFunc(null)}>
                            <p>{langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}</p>
                        </button>
                    </div>
                </div>
            </div>
        )}
        </>
    )
}

export default MembGameSvcGiftOdrLstUi;